const MINUTES_PER_HOUR = 60;
const MILLISECONDS_PER_MINUTE = 60000;

export const CACHE_TIME = 12 * MINUTES_PER_HOUR * MILLISECONDS_PER_MINUTE;
export const STALE_TIME = 12 * MINUTES_PER_HOUR * MILLISECONDS_PER_MINUTE;

export const IDLE_TIMEOUT = MILLISECONDS_PER_MINUTE * 30;
